import Vue from 'vue';
import MamiChat from 'mamichat';

Vue.use(MamiChat, {
  mamikosBaseUrl: process.env.MAMIKOS_URL,
});
